import MainPage from '@/components/pages/main';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';
import CatchError from '@/components/system/CacthError';
import { redirect } from 'next/navigation';
import { useRouter } from 'next/router';
import { convertQueryObjectToQueryString } from '@/utils/convertQueryObjectToQueryString';
import {
  isFomoBoxGame,
  isWoWSpaceView,
  isSquidGame,
} from '@/utils/checkRuntime';

export interface AppHomePageProps {
  children: React.ReactNode;
}

// export const runtime = 'experimental-edge';
export function AppHomePage(props: AppHomePageProps) {
  const { query } = useRouter();

  if (isWoWSpaceView && isFomoBoxGame) {
    redirect(`/wow?${convertQueryObjectToQueryString(query)}`);
  }

  redirect(`/casino?${convertQueryObjectToQueryString(query)}`);

  return (
    <>
      <MainPage />
    </>
  );
}

export async function getServerSideProps({ locale, query }) {
  const queryString = convertQueryObjectToQueryString(query);

  if (isWoWSpaceView) {
    return {
      redirect: {
        permanent: false,
        destination: `/wow?${queryString}`,
      },
      props: {
        ...(await serverSideTranslations(locale, ['common', 'rewards', 'box'])),
        // Will be passed to the page component as props
      },
    };
  }

  return {
    redirect: {
      permanent: false,
      destination: `/casino${queryString ? '?' : ''}${queryString}`,
    },
    props: {
      ...(await serverSideTranslations(locale, ['common', 'rewards', 'box'])),
      // Will be passed to the page component as props
    },
  };


}

export default CatchError(AppHomePage);
